{
  "familyId": "SPR-WEET-DT",
  "questions": [
    {
      "id": "SPR-WEET-DT-001",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een dt-fout?",
      "options": [],
      "correctAnswer": 2,
      "data": {
        "sentences": [
          { "text": "Hij vindt het moeilijk om stil te zitten.", "hasError": false, "explanation": "Correct: vinden → stam 'vind' + t = vindt." },
          { "text": "Mijn moeder wordt morgen jarig.", "hasError": false, "explanation": "Correct: worden → stam 'word' + t = wordt." },
          { "text": "De hond word steeds groter.", "hasError": true, "correction": "De hond wordt steeds groter.", "explanation": "Fout: 'de hond' = hij/zij → stam 'word' + t = wordt." },
          { "text": "Zij houdt niet van spinazie.", "hasError": false, "explanation": "Correct: houden → stam 'houd' + t = houdt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De dt-regel", "content": "Bij hij, zij, het of een naam gebruik je in de tegenwoordige tijd de stam + t.\nAls de stam op -d eindigt, krijg je -dt.\n\nWorden → stam = word → hij wordt\nVinden → stam = vind → zij vindt\nHouden → stam = houd → het houdt", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_sentence_judge_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'De hond' is derde persoon (hij). Worden → stam = word. Bij 'hij': stam + t = wordt. Zonder de -t is het fout.",
        "solutionSteps": ["De hond = hij (3e persoon)", "Infinitief: worden → stam: word", "Stam + t = wordt", "Dus: 'De hond wordt steeds groter.'"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-002",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "error_spotting",
      "question": "Zoek de dt-fouten in deze tekst. Tik op het foute woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Lisa fietst elke dag naar school. Ze vind het fijn als de zon schijnt. Haar broer rijdt altijd mee. Hij word soms boos als ze te laat vertrekt.",
        "errors": [
          { "word": "vind", "position": 7, "correction": "vindt", "rule": "Ze = zij (3e persoon). Vinden → stam 'vind' + t = vindt." },
          { "word": "word", "position": 20, "correction": "wordt", "rule": "Hij = 3e persoon. Worden → stam 'word' + t = wordt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stam + t bij hij/zij/het", "content": "Bij hij, zij of het in de tegenwoordige tijd: stam + t.\n\nVinden → stam = vind → zij vindt\nWorden → stam = word → hij wordt\n\nLet op: 'fietst' en 'rijdt' zijn al correct in deze tekst!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_spotting_mixed",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Twee fouten: 'vind' moet 'vindt' zijn (ze = zij, 3e persoon) en 'word' moet 'wordt' zijn (hij, 3e persoon). Let op: 'fietst' en 'rijdt' zijn wél correct.",
        "solutionSteps": ["Ze vind → ze vindt (stam 'vind' + t)", "Hij word → hij wordt (stam 'word' + t)", "'Fietst' is correct: fietsen → stam 'fiets' + t", "'Rijdt' is correct: rijden → stam 'rijd' + t"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-003",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een dt-fout?",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "sentences": [
          { "text": "Vind jij dat ook zo vreemd?", "hasError": false, "explanation": "Correct: bij inversie (jij achter het werkwoord) vervalt de -t. Dus: 'vind jij'." },
          { "text": "Jij word steeds beter in rekenen.", "hasError": true, "correction": "Jij wordt steeds beter in rekenen.", "explanation": "Fout: 'jij' vóór het werkwoord → stam + t = wordt." },
          { "text": "Zij snijdt de taart in stukken.", "hasError": false, "explanation": "Correct: snijden → stam 'snijd' + t = snijdt." },
          { "text": "Bind jij even het touw vast?", "hasError": false, "explanation": "Correct: bij inversie vervalt de -t. Binden → stam 'bind'. Dus: 'bind jij'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie: jij + werkwoord", "content": "Als 'jij' VÓÓR het werkwoord staat: stam + t.\n→ Jij vindt, jij wordt, jij houdt\n\nAls 'jij' ACHTER het werkwoord staat (inversie): alleen de stam, GEEN -t.\n→ Vind jij? Word jij? Houd jij?\n\nDit is een veelgemaakte fout!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_inversie_judge",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Jij' staat vóór het werkwoord, dus je gebruikt stam + t: 'jij wordt'. Regel: bij 'jij' vóór het werkwoord → stam + t. Bij inversie ('word jij?') vervalt de -t. Worden → stam = word → jij wordt.",
        "solutionSteps": ["Jij + worden: jij staat VÓÓR het werkwoord", "Regel: jij vóór werkwoord → stam + t", "Stam = word, stam + t = wordt", "Dus: 'Jij wordt steeds beter in rekenen.'", "Vergelijk inversie: 'Word jij beter?' (geen -t)"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-004",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "error_spotting",
      "question": "Zoek de dt-fouten in deze tekst. Tik op het foute woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Opa bindt de veters van zijn schoenen. Hij snijd daarna een stuk brood af. Oma vindt dat hij te langzaam eet. Zij houd de klok goed in de gaten.",
        "errors": [
          { "word": "snijd", "position": 7, "correction": "snijdt", "rule": "Hij = 3e persoon. Snijden → stam 'snijd' + t = snijdt." },
          { "word": "houd", "position": 20, "correction": "houdt", "rule": "Zij = 3e persoon (enkelvoud). Houden → stam 'houd' + t = houdt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stam + t: let op de d!", "content": "Bij hij, zij of het: stam + t.\n\nSnijden → stam = snijd → hij snijdt\nHouden → stam = houd → zij houdt\n\nLet op: 'bindt' en 'vindt' zijn al correct in deze tekst. Niet elke -dt is fout!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_spotting_advanced",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Twee fouten gevonden. Regel: bij hij/zij/het gebruik je stam + t. Snijden → stam 'snijd' + t = snijdt. Houden → stam 'houd' + t = houdt. Let op: 'bindt' en 'vindt' zijn wél correct — niet elke -dt is fout!",
        "solutionSteps": ["Regel: bij hij/zij/het → stam + t", "Hij snijd → hij snijdt (stam 'snijd' + t)", "Zij houd → zij houdt (stam 'houd' + t)", "'Bindt' is correct: binden → stam 'bind' + t", "'Vindt' is correct: vinden → stam 'vind' + t"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-005",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: 'Hij ... (vinden) het leuk.' Typ het woord.",
      "correctAnswer": "vindt",
      "data": {
        "acceptedAnswers": ["vindt"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vinden → hij vindt", "content": "Bij 'hij/zij/het' gebruik je de stam + t. De stam van 'vinden' is 'vind'. Omdat de stam al op -d eindigt, krijg je -dt: hij vindt. Dit is geen dt-fout — het is de gewone regel!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_vindt_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' gebruik je de stam + t. De stam van 'vinden' is 'vind'. Omdat de stam al eindigt op -d, krijg je -dt wanneer je de -t toevoegt: hij vindt. Dit is de gewone regel voor werkwoorden waarvan de stam op -d eindigt. Andere voorbeelden: hij wordt (stam: word), zij houdt (stam: houd).",
        "solutionSteps": ["Infinitief: vinden", "Stam bepalen: vind (streep -en eraf)", "Bij 'hij': stam + t = vind + t = vindt", "Check: de -d hoort bij de stam, de -t is de uitgang"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-006",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Mijn vader rijd elke dag naar zijn werk. Hij vind het fijn om vroeg te beginnen. Soms houd hij pauze bij een tankstation.",
        "errors": [
          { "word": "rijd", "position": 2, "correction": "rijdt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (rijdt)" },
          { "word": "vind", "position": 9, "correction": "vindt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (vindt)" },
          { "word": "houd", "position": 17, "correction": "houdt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (houdt)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De dt-regel bij hij/zij/het",
            "content": "Bij hij, zij of het gebruik je in de tegenwoordige tijd de stam + t. Als de stam al op een -d eindigt (zoals bij rijden, vinden, houden), krijg je dus -dt: hij rijdt, hij vindt, hij houdt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "dt_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' of 'mijn vader' gebruik je in de tegenwoordige tijd altijd de stam + t. Omdat de stam van rijden, vinden en houden al op een -d eindigt, krijg je -dt: rijdt, vindt, houdt.",
        "solutionSteps": [
          "Mijn vader (hij) + rijden = rijdt",
          "Hij + vinden = vindt",
          "Hij + houden = houdt"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-DT-007",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "word_builder",
      "question": "Bouw het hele woord. Let op de -dt!",
      "context": "Eindigt de stam al op een d? Bij hij/zij komt er nog een t bij: vind + t = vindt.",
      "data": {
        "wordBuilder": {
          "variant": "dt",
          "items": [
            { "clue": "Hij ___ zijn sleutels terug (van vinden).", "word": "vindt" },
            { "clue": "Zij ___ op haar fiets naar huis (van rijden).", "word": "rijdt" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De -dt-regel",
            "content": "Eindigt de stam op een d? Bij hij/zij/het voeg je tóch een -t toe: vind + t = vindt, rij + dt = rijdt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weet_bouw_dt",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Vinden' heeft stam 'vind'; bij 'hij' komt er een -t bij: vindt. 'Rijden' heeft stam 'rij'; bij 'zij' wordt het rij + dt = rijdt.",
        "solutionSteps": [
          "vind + t → vindt",
          "rij + dt → rijdt"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.dt-overgeneralize", "label": "-dt onjuist gebouwd" }
        ]
      }
    }
  ]
}